function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Link, ListItem, ListItemText } from '@material-ui/core';
import { useStyles } from "./styles.js";
export const MenuItem = ({
  to,
  label,
  anchor,
  component,
  external,
  mobile,
  onClose
}) => {
  const classes = useStyles();
  let hrefProps = {
    target: '_self'
  };

  if (anchor || external) {
    hrefProps.href = to;

    if (external) {
      hrefProps.target = '_blank';
      hrefProps.rel = 'noopener noreferrer';
    }
  } else {
    hrefProps.to = to;
  }

  return mobile ? /*#__PURE__*/React.createElement(ListItem, _extends({}, hrefProps, {
    component: component,
    onClick: onClose,
    button: true
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: label
  })) : /*#__PURE__*/React.createElement(Link, _extends({}, hrefProps, {
    component: component,
    className: !mobile && classes.link,
    underline: "none"
  }), label);
};
MenuItem.defaultProps = {
  component: 'a',
  mobile: false
};
MenuItem.displayName = 'MenuItem';
export default MenuItem;